/**
 * The Commerce Ops mark, "8b · O held by C" from the Basalt logo concepts
 * (Claude design project c746bd19, CO-116): the C, commerce, in ink — it
 * takes the surrounding text colour — wraps a solid green O, the ops core.
 * The green comes from --brand-mark-dot, which the theme sets (teal-400 on
 * light, teal-300 on dark).
 *
 * Decorative by default, because it always sits next to the product name;
 * pass a title when the mark stands alone.
 */
export function BrandMark({ size = 22, className, title }: { size?: number; className?: string; title?: string }) {
  return (
    <svg
      className={className ? `brand-mark ${className}` : 'brand-mark'}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
      focusable="false"
    >
      <path d="M23.8 8.2A11 11 0 1 0 23.8 23.8" stroke="currentColor" strokeWidth="3.8" strokeLinecap="round" />
      <circle cx="16" cy="16" r="4.6" fill="var(--brand-mark-dot)" />
    </svg>
  );
}
